import Vue from 'vue'
import BootstrapVue from 'bootstrap-vue'
import axios from 'axios'
import vbclass from 'vue-body-class'
import VueI18n from 'vue-i18n'
import VueMobileDetection from 'vue-mobile-detection'

import App from '@/App.vue'
import router from '@/router'
import store from '@/store'

import { API_URL_BASE, AUTH_TOKEN_NAME } from '@/config'

import '@/registerServiceWorker'
import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import './assets/sass/app.scss'

const isProduction = process.env.NODE_ENV === 'production'
const savedLanguage = localStorage.getItem('selectedLanguage')
const defaultLanguage = savedLanguage || 'en'
// Global components
window._ = require('lodash')
window.axios = axios

axios.defaults.baseURL = (isProduction) ? API_URL_BASE : 'http://dev.api.example.com/v1'
axios.defaults.headers.common['Authorization'] = `Bearer ${localStorage.getItem(AUTH_TOKEN_NAME)}`

Vue.use(BootstrapVue)
Vue.use(vbclass, router)
Vue.use(VueI18n)
Vue.use(VueMobileDetection)

Vue.config.productionTip = false

const messages = {
  en: require('./lang/en.json'),
  pl: require('./lang/pl.json'),
  uk: require('./lang/uk.json')
}

const i18n = new VueI18n({
  locale: defaultLanguage,
  messages
})

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
